<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div v-if="!modoVisualizacao">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata">
                <RangeDataSelect :periodoInicial="'currentMonth'" v-model="dateRange" />
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Tipo Atividade</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item">
                <div v-if="globalStore.ckperfilinspetor">
                    <label class="label-caption">SIM</label>
                    <div class="field-label">{{ globalStore.nmsim }}</div>
                </div>
                <div v-if="!globalStore.ckperfilinspetor">
                    <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
                </div>
            </div>
            
            <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="idEstabelecimento" />
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closePage" />
        </div>


        <div v-if="lsDados.length > 0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th>Data</th>
                    <th>Estabelecimento</th>
                    <th>Tipo Atividade</th>
                    <th>Nome Responsável</th>
                </tr></thead>

                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.idregistro" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                    @click="visualizarRegistro(obj)">
                        <td class="col-width-data center">{{ Funcoes.formatDateFromJson(obj.dtatividade) }}</td>
                        <td>{{ obj.nmestabelecimento }}</td>
                        <td class="col-width-char30">{{ obj.tpatividade }}</td>
                        <td class="col-width-char30">{{ obj.nmresponsavel }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        
        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>
    

    <div v-if="modoVisualizacao">
        <div v-if="showPLA01"><Pla01ViewPage :idView="idView" @close="modoVisualizacao = false" /></div>
        <div v-if="showPLA06"><Pla06ViewPage :idView="idView" @close="modoVisualizacao = false" /></div>
        <div v-if="showVistoria"><VistoriaViewPage :idView="idView" @close="modoVisualizacao = false" /></div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import Pla01ViewPage from '../visualizacoes/Pla01ViewPage.vue';
import Pla06ViewPage from '../visualizacoes/Pla06ViewPage.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';
import VistoriaViewPage from '../visualizacoes/VistoriaViewPage.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "currentMonth", endDate: "", selectedPeriod: "" });
const idEstabelecimento = ref(null);
const idSim = ref(null);
const idView = ref(null);
const isLoading = ref(false);
const modoVisualizacao = ref(false);
const msgAlerta = ref(null);
const showPLA01 = ref(false);
const showPLA06 = ref(false);
const showVistoria = ref(false);
const lsDados = ref([]);

const lsOpcoes = ref([
    {id: '',        descricao: 'TODAS'},
    {id: 'PLA01',   descricao: 'COLETAS'},
    {id: 'PLA06',   descricao: 'VISTORIAS'},
]);
const opcaoSelecionada = ref('');

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closePage = () => {emit('close');}

const lerDados = async() => {
    const r = Validar.intervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
    if (!r.ok){msgAlerta.value = r.msg; return;}

    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.ckperfilinspetor ? globalStore.idsim : idSim.value,
            idestabelecimento: idEstabelecimento.value,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate,
            strparam1: opcaoSelecionada.value
        };
        const req = await Api.genericPost('/listas/historico_atividades', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

const visualizarRegistro = (obj) =>{
    showPLA01.value=(obj.nmtabela==='PLA01');
    showPLA06.value=(obj.nmtabela==='PLA06');
    showVistoria.value=(obj.nmtabela==='VISTORIA');
    idView.value = obj.idregistro;
    modoVisualizacao.value = showPLA06.value || showPLA01.value || showVistoria;
}

onMounted(lerDados);
</script>